import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalSkeleton from "components/PopUps/ModalSkeleton";
// import VideoIcon from "assets/images/video-icon.svg"; // adjust path
import { s3base } from "api";
import Image from "components/Image/Image";
import Category from "components/StgyVideos/Category";

const FinalTips = ({ video }) => {
  const [modelStatus, setModelStatus] = useState(false);
  const navigate = useNavigate();

  const modelHandler = () => {
    if (!video.link) {
      setModelStatus((prevState) => !prevState);
      return;
    }
    navigate("/admin/video/" + video.id);
  };

  return (
    <div className="final-tips-wrapper" id="final-tips">
      <div className="final-tips-title">Final Tips</div>
      <p className="final-tips-description mx-0">
        More than 500 students got their desired score with LA in the last month. 
        These Final Tips could help you
      </p>

      {/* <button className="final-tips-btn" onClick={modelHandler}>
        Final Tips for Exams
          <Image path={s3base + video.thumbnail} alt="" classes="" />
      </button> */}
      <Category.List>
        <Category.Item
        title={video?.title}
        description={video?.description}
        thumbnail={video?.thumbnail}
        vidLink={video?.link}
        id={video?.id}
        />
        </Category.List>

      {!video?.link && (
        <ModalSkeleton
          status={modelStatus}
          toggle={modelHandler}
          handleClick={() => {
            navigate("/admin/plans");
          }}
          btnText="Buy Plan"
          message="Please subscribe to our gold plan to see Secret Strategy Videos"
          isSmall={true}
        />
      )}
    </div>
  );
};

export default FinalTips;
